import api from './api';

function checkedResponse(response) {
  const meta = response?.data || {};
  if (meta.error || (meta.code != null && Number(meta.code) !== 200)) {
    throw new Error(meta.message || 'Unable to load topics.');
  }
  return { payload: meta.dataset?.data || {}, meta };
}

const LECTURES_CATEGORY_ID = 3;
const NOTES_CATEGORY_ID = 4;
const FLASH_CARDS_CATEGORY_ID = 9;
const PODCAST_CATEGORY_ID = 12;
const INFOGRAPHICS_CATEGORY_ID = 13;

function isNotesCategory(params = {}) {
  return Number(params?.category_id || 0) === NOTES_CATEGORY_ID;
}

function isPodcastCategory(params = {}) {
  return Number(params?.category_id || 0) === PODCAST_CATEGORY_ID;
}

function isFlashCardsCategory(params = {}) {
  return Number(params?.category_id || 0) === FLASH_CARDS_CATEGORY_ID;
}

function isInfographicsCategory(params = {}) {
  return Number(params?.category_id || 0) === INFOGRAPHICS_CATEGORY_ID;
}

function isLecturesCategory(params = {}) {
  return Number(params?.category_id || 0) === LECTURES_CATEGORY_ID;
}

function resolveTopicEndpoint(params, questionBankEndpoint, notesEndpoint, flashCardsEndpoint, podcastEndpoint, infographicsEndpoint, lecturesEndpoint) {
  if (isNotesCategory(params)) return notesEndpoint;
  if (isFlashCardsCategory(params)) return flashCardsEndpoint;
  if (isPodcastCategory(params)) return podcastEndpoint;
  if (isInfographicsCategory(params)) return infographicsEndpoint;
  if (isLecturesCategory(params)) return lecturesEndpoint;
  return questionBankEndpoint;
}

export async function fetchQuestionBankTopics(params = {}) {
  const response = await api.get(resolveTopicEndpoint(params, '/get-topics', '/notes/get-topics', '/flash-cards/get-topics', '/audio-podcast/get-topics', '/infographics/get-topics', '/lectures/get-topics'), {
    params,
  });

  return checkedResponse(response);
}

export async function fetchQuestionBankTopicDetail(params = {}) {
  const response = await api.get(resolveTopicEndpoint(params, '/get-topic-detail', '/notes/get-topic-detail', '/flash-cards/get-topic-detail', '/audio-podcast/get-topic-detail', '/infographics/get-topic-detail', '/lectures/get-topic-detail'), {
    params,
  });

  return checkedResponse(response);
}

export async function fetchQuestionBankSubTopics(params = {}) {
  const response = await api.get(resolveTopicEndpoint(params, '/get-sub-topics', '/notes/get-sub-topics', '/flash-cards/get-sub-topics', '/audio-podcast/get-sub-topics', '/infographics/get-sub-topics', '/lectures/get-sub-topics'), {
    params,
  });

  return checkedResponse(response);
}

export async function fetchQuestionBankSubTopicDetail(params = {}) {
  const response = await api.get(resolveTopicEndpoint(params, '/get-sub-topic-detail', '/notes/get-sub-topic-detail', '/flash-cards/get-sub-topic-detail', '/audio-podcast/get-sub-topic-detail', '/infographics/get-sub-topic-detail', '/lectures/get-sub-topic-detail'), {
    params,
  });

  return checkedResponse(response);
}
